import React from 'react';
import { Box, Typography, Stack } from '@mui/material';
import Grid from '@mui/material/Grid';
import { Link as RouterLink } from 'react-router-dom';

const Footer: React.FC = () => (
  <Box
    component="footer"
    sx={{
      bgcolor: '#0a0a12',
      borderTop: '1px solid rgba(255,255,255,0.06)',
      pt: 6,
      pb: 4,
      px: { xs: 3, md: 6 },
    }}
  >
    <Grid container spacing={4} sx={{ maxWidth: 1100, mx: 'auto', mb: 4 }}>
      {/* Col 1: Logo + tagline */}
      <Grid size={{ xs: 12, md: 5 }}>
        <img src="/logo.png" alt="Smart Media Clarity" style={{ maxHeight: 36, width: 'auto', display: 'block', marginBottom: 12 }} />
        <Typography variant="body2" sx={{ color: '#9499b0', lineHeight: 1.7, maxWidth: 320, fontFamily: 'Inter, system-ui, sans-serif', fontSize: 13 }}>
          AI-powered child safety and transparency — helping daycares protect children, staff, and reputation automatically.
        </Typography>
      </Grid>

      {/* Col 2: Navigation */}
      <Grid size={{ xs: 6, md: 3 }}>
        <Typography variant="overline" sx={{ color: '#f0f0f8', fontFamily: 'Inter, system-ui, sans-serif', fontSize: 11, letterSpacing: '0.1em', fontWeight: 600, display: 'block', mb: 1.5 }}>
          Product
        </Typography>
        <Stack spacing={1}>
          {[{ label: 'Home', to: '/' }, { label: 'Why It Matters', to: '/why' }, { label: 'For Staff & Operators', to: '/for-staff' }, { label: 'About Us', to: '/about' }, { label: 'Privacy & Security', to: '/privacy' }, { label: 'Contact', to: '/contact' }].map(({ label, to }) => (
            <RouterLink
              key={to}
              to={to}
              style={{ textDecoration: 'none' }}
            >
              <Typography variant="body2" sx={{ color: '#9499b0', fontFamily: 'Inter, system-ui, sans-serif', fontSize: 13, transition: 'color 0.2s', '&:hover': { color: '#f0f0f8' } }}>
                {label}
              </Typography>
            </RouterLink>
          ))}
        </Stack>
      </Grid>

      {/* Col 3: Partners */}
      <Grid size={{ xs: 6, md: 2 }}>
        <Typography variant="overline" sx={{ color: '#f0f0f8', fontFamily: 'Inter, system-ui, sans-serif', fontSize: 11, letterSpacing: '0.1em', fontWeight: 600, display: 'block', mb: 1.5 }}>
          Partners
        </Typography>
        <Stack spacing={1}>
          <RouterLink to="/insurance-partners" style={{ textDecoration: 'none' }}>
            <Typography variant="body2" sx={{ color: '#9499b0', fontFamily: 'Inter, system-ui, sans-serif', fontSize: 13, transition: 'color 0.2s', '&:hover': { color: '#f0f0f8' } }}>
              Insurance Partners
            </Typography>
          </RouterLink>
          <RouterLink to="/enterprise" style={{ textDecoration: 'none' }}>
            <Typography variant="body2" sx={{ color: '#9499b0', fontFamily: 'Inter, system-ui, sans-serif', fontSize: 13, transition: 'color 0.2s', '&:hover': { color: '#f0f0f8' } }}>
              Enterprise
            </Typography>
          </RouterLink>
        </Stack>
      </Grid>

      {/* Col 4: Contact info */}
      <Grid size={{ xs: 6, md: 2 }}>
        <Typography variant="overline" sx={{ color: '#f0f0f8', fontFamily: 'Inter, system-ui, sans-serif', fontSize: 11, letterSpacing: '0.1em', fontWeight: 600, display: 'block', mb: 1.5 }}>
          Contact
        </Typography>
        <Stack spacing={1}>
          <Typography variant="body2" sx={{ color: '#9499b0', fontFamily: 'Inter, system-ui, sans-serif', fontSize: 13 }}>
            admin@smartmediaclarity.com
          </Typography>
          <Typography variant="body2" sx={{ color: '#9499b0', fontFamily: 'Inter, system-ui, sans-serif', fontSize: 13 }}>
            Pilot program — limited spots
          </Typography>
        </Stack>
      </Grid>
    </Grid>

    {/* Bottom bar */}
    <Box sx={{ borderTop: '1px solid rgba(255,255,255,0.06)', pt: 3, maxWidth: 1100, mx: 'auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>
      <Typography variant="body2" sx={{ color: '#9499b0', fontFamily: 'Inter, system-ui, sans-serif', fontSize: 12 }}>
        &copy; {new Date().getFullYear()} Smart Media Clarity. All rights reserved.
      </Typography>
      <Typography variant="body2" sx={{ color: 'rgba(148,153,176,0.5)', fontFamily: 'Inter, system-ui, sans-serif', fontSize: 12 }}>
        Built with care for children and communities.
      </Typography>
    </Box>
  </Box>
);

export default Footer;
